import React, { ComponentProps, useEffect, useMemo, useState } from "react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import { configuration } from "e.sic-platform.webclient/src/services/configuration/ConfigurationService";

export function AppMsalProvider({ children }: { children: React.ReactNode }) {
  const [ configurationContent, setConfig ] = useState<any>();

  const authClientApp = useMemo(
    () =>
      configurationContent
        ? new PublicClientApplication({
            auth: {
              clientId: configurationContent.clientId,
              authority: `${configurationContent.authority}/${configurationContent.sign_up_and_in_user_flow}`,
              redirectUri: configurationContent.redirect_uri,
              postLogoutRedirectUri: configurationContent.redirect_uri,
              knownAuthorities: configurationContent.knownAuthorities,
            },
            cache: {
              cacheLocation: "localStorage"
            },
            system: {
              navigateFrameWait: 0,
            },
          })
        : undefined,
    [configurationContent]
  );

  useEffect(() => {
    configuration.get().then((response:any) => setConfig(response))
  }, [])

  if (authClientApp) {
    return <MsalProvider instance={authClientApp}>{children}</MsalProvider>;
  } else {
    return <></>;
  }
}

export default function useMsalProvider() {}
useMsalProvider.Provider = AppMsalProvider;
useMsalProvider.FakeProvider = () => (props: ComponentProps<any>) => <>{props.children}</>;